<template>
    <div>
        <div class="flexsplit">
            <div>
                <v-text-field label="Título" v-model="title" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Link" v-model="link" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Meta Tags" v-model="meta_tags" :disabled="permission.write?null:true"></v-text-field>
                <v-textarea
                    label="Meta Description"
                    rows="1"
                    auto-grow
                    :disabled="permission.write?null:true"
                    v-model="meta_description">
                </v-textarea>
            </div>

            <left-slider
                :disabled="permission.write?null:true"
                v-model="left_slider" />
        </div>
        <br />

        <label class="fluke-editor-label">Conteúdo</label>
        <fluke-editor
            :disabled="permission.write?null:true"
            v-model="content"
            :key="keyer" />
    </div>
</template>

<script>
import permission from '../../../mixins/permissions';
import leftSlider from '../../../components/Main/Content/LeftSlider/LeftSlider';
import flukeEditor from '../../../components/Main/Content/Editor/Editor';


export default {
    mixins: [ permission ],
    components: {
        leftSlider,
        flukeEditor
    },
    data()
    {
        return {
            permission: false,
            keyer: 0
        }
    },
    computed: {
        content: {
            get()
            {
                if( this.$store.state.page.content ) return this.$store.state.page.content;
                else return '';
            },
            set( value )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'content',
                    data: value
                });
            }
        },
        title: {
            get()
            {
                if( this.$store.state.page.title ) return this.$store.state.page.title;
                else return '';
            },
            set( value )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'title',
                    data: value
                });
            }
        },
        link: {
            get()
            {
                if( this.$store.state.page.link ) return this.$store.state.page.link;
                else return '';
            },
            set( value )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'link',
                    data: value
                });
            }
        },
        meta_tags: {
            get()
            {
                if( this.$store.state.page.meta_tags ) return this.$store.state.page.meta_tags;
                else return '';
            },
            set( meta_tags )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'meta_tags',
                    data: meta_tags
                });
            }
        },
        meta_description: {
            get()
            {
                if( this.$store.state.page.meta_description ) return this.$store.state.page.meta_description;
                else return '';
            },
            set( value )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'meta_description',
                    data: value
                });
            }
        },
        left_slider: {
            get()
            {
                const value = this.$store.state.page.left_slider;
                if( value )
                {
                    if( value.indexOf('[') !== -1 )
                    {
                        return JSON.parse( value )
                    }
                }
                return [];
            },
            set( value )
            {
                this.$store.commit( 'set_pagedata', {
                    field: 'left_slider',
                    data: JSON.stringify( value )
                });
            }
        },
    },
    watch: {
        content()
        {
            // no re-render bug fix
            if( this.keyer == 0 ) this.keyer++;
        }
    },
    created()
    {
        this.permission = this.getUserPagePermission('pages');
		if( this.permission.read == false ) {
			this.$router.push('/');
        }
    }
}
</script>